// import { login, getInfo, getMenu } from '@/utils/api/login'
// import { getToken, setToken, removeToken } from '@/utils/auth'
import request from '@/utils/request'

const qiniu = {
  state: {
    uploadToken: '',
    createdAt: 0
  },

  mutations: {
    SET_QI_NIU_TOKEN: (state, token) => {
      state.uploadToken = token
    },
    SET_QI_NIU_CREATED_AT: (state, date) => {
      state.createdAt = date
    }
  },

  actions: {
    GetQiNiuUploadToken({ commit, state }) {
      const token = state.uploadToken
      const createdAt = state.createdAt
      return new Promise((resolve, reject) => {
        var fetchFlag = true
        // 如果已经有token，并且没有过期，直接使用
        if (token.length > 0 && createdAt > 0) {
          const nowSeconds = Math.round(new Date() / 1000)
          // 七牛上我设置的是 3600 秒 随意这里写 3000 秒过期，以防万一
          if (createdAt + 3000 > nowSeconds) {
            fetchFlag = false
          }
        }

        if (fetchFlag) {
          // 如果过期或者没有token，调用API进行获取，并且设置
          commit('SET_QI_NIU_TOKEN', '')
          commit('SET_QI_NIU_CREATED_AT', 0)
          request({
            url: '/upload-token',
            method: 'get'
          })
            .then(response => {
              commit('SET_QI_NIU_TOKEN', response.data.token)
              commit('SET_QI_NIU_CREATED_AT', Math.round(new Date() / 1000))
              resolve(response.data.token)
            })
            .catch(error => {
              reject(error)
            })
        } else {
          resolve(token)
        }
      })
    }
  }
}

export default qiniu
